import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/home/home.vue'),
      meta: {
        index: 0,
        title: '寰储-鍒涙柊閲戣瀺鏈嶅姟,鍒涢€犵編濂界敓娲?
      }
    },
    {
      path: '/WeTechnology',
      name: 'WeTechnology',
      component: () => import('@/pages/weTech/index.vue'),
      meta: {
        index: 1,
        title: '寰储-鍒涙柊閲戣瀺鏈嶅姟,鍒涢€犵編濂界敓娲?
      }
    },
    // 鏍规嵁闇€姹俬ttps://www.tapd.cn/tapd_fe/61584214/story/detail/1161584214001052247
    // 杩涜涓嬬嚎澶勭悊
    // {
    //   path: '/WeProduct',
    //   name: 'WeProduct',
    //   component: () => import('@/pages/weProduct'),
    //   meta: {
    //     index: 2,
    //     title: '濂藉垎鏈?寰储鏃椾笅鍒嗘湡鍊熸骞冲彴'
    //   }
    // },
    // {
    //   path: '/WeCulture',
    //   name: 'WeCulture',
    //   component: () => import('@/pages/weCulture'),
    //   meta: {
    //     index: 3,
    //     title: '浼佷笟鏂囧寲-寰储'
    //   }
    // },
    {
      path: '/WeAbout',
      name: 'WeAbout',
      component: () => import('@/pages/aboutWe/aboutWe.vue'),
      meta: {
        index: 4,
        title: '鍏充簬鎴戜滑-寰储'
      }
    },
    {
      path: '/WeNewsDetail',
      name: 'WeNewsDetail',
      component: () => import('@/pages/weNewsDetail'),
      meta: {
        index: 5,
        title: '鍏充簬鎴戜滑-寰储'
      }
    },
    {
      path: '/responsibility',
      name: 'responsibility',
      component: () => import('@/pages/responsibility/index.vue'),
      meta: {
        index: 6,
        title: '绀句細璐ｄ换-寰储'
      }
    },
    {
      path: '*',
      name: 'Home',
      component: () => import('@/pages/home/home.vue'),
      meta: {
        index: 0,
        title: '寰储-鍒涙柊閲戣瀺鏈嶅姟,鍒涢€犵編濂界敓娲?
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js